import { render, staticRenderFns } from "./BuyerAccountDetails.vue?vue&type=template&id=4df86228&scoped=true"
import script from "./BuyerAccountDetails.vue?vue&type=script&lang=js"
export * from "./BuyerAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./BuyerAccountDetails.vue?vue&type=style&index=0&id=4df86228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df86228",
  null
  
)

export default component.exports